import { db, storage, functions } from "./firebase";
import { collection, addDoc, getDocs, query, where, limit, doc, getDoc, updateDoc, deleteDoc, setDoc, orderBy, arrayUnion, arrayRemove, startAfter } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject  } from "firebase/storage";
// import { toast } from "react-toastify";
// import { v4 as uuidv4 } from "uuid";
// import { flatten } from "flat";
// import { getUser } from "./authentication";
import { httpsCallable, connectFunctionsEmulator } from "firebase/functions";

const calendar = {};


export async function getCalendar() {
  // const toastId = toast.loading("Loading Your Item...")
  try {
    const q = query(doc(db, "calendar", "calendar"));
    const item = await getDoc(q);
    // console.log(item.data())
    if (!item.exists()) {
      // toast.update(toastId, {render: "An error occured.  Try checking your internet connection.", isLoading: false, autoClose: 3000, type: "error"});
      // toast.error("An error occured.  Try checking your internet connection.");
      return false;
    }
    // toast.update(toastId, {render: "Success!", type: "success", isLoading: false, autoClose: 2000});
    const data =  item.data();
    // console.log(data)
    // calendar = data;
    // console.log(calendar)
    return data
  } catch (e) {
    // toast.update(toastId, {render: "An error occured.  Try checking your internet connection.", isLoading: false, autoClose: 3000, type: "error"});
    // toast.error("An error occured.  Try checking your internet connection.")
  }

}

export async function getTutor(day, time, subjects) {
  // const toastId = toast.loading("Loading Your Item...")
  try {
    let tutor;
    const q = query(collection(db, "tutors")
  ,where(day, "array-contains", time),...subjects.map(subject => where(`subjects.${subject}`, "==", true)),limit(1), where("verified", "==", true));
      const docs = await getDocs(q);
      docs.forEach(item => {
      if (!item.data()) return null;
      const data = item.data()
      tutor = {id: item.id, ...data};
      // if (data.category) {items.push({...data, id: item.id})}
    });
    return tutor;
  } catch (e) {
    console.log(e)
    // toast.update(toastId, {render: "An error occured.  Try checking your internet connection.", isLoading: false, autoClose: 3000, type: "error"});
    // toast.error("An error occured.  Try checking your internet connection.")
  }
}


export async function getTimes(day, subjects) {
  // const toastId = toast.loading("Loading Your Item...")
  const times = (day === "saturday" || day === "sunday")? ["8:30 am", "9:00 am", "9:30 am", "10:00 am", "10:30 am", "11:00 am", "11:30 am", "12:00 pm", "12:30 pm", "1:00 pm", "1:30 pm", "2:00 pm", "2:30 pm","3:00 pm", "3:30 pm", "4:00 pm", "4:30 pm", "5:00 pm", "5:30 pm", "6:00 pm", "6:30 pm", "7:00 pm", "7:30 pm", "8:00 pm", "8:30 pm", "9:00 pm", "9:30 pm", "10:00 pm"]:["10:00 am", "10:30 am", "11:00 am", "11:30 am", "12:00 pm", "12:30 pm", "1:00 pm","1:30 pm", "2:00 pm", "2:30pm","3:00 pm", "3:30 pm", "4:00 pm", "4:30 pm", "5:00 pm", "5:30 pm", "6:00 pm", "6:30 pm", "7:00 pm", "7:30 pm", "8:00 pm", "8:30 pm", "9:00 pm", "9:30 pm", "10:00 pm"];
  try {
    const availability = [];
    await Promise.all(times.map(async (time) => {
      const q = query(collection(db, "tutors")
    ,where(day, "array-contains", time),...subjects.map(subject => where(`subjects.${subject}`, "==", true)),limit(1), where("verified", "==", true));
      const docs = await getDocs(q);
      docs.forEach(item => {
      if (!item.data()) return null;
      const data = item.data()
      availability.push(time);
      return true;
      // if (data.category) {items.push({...data, id: item.id})}
    });
    }))
      return availability;
  } catch (e) {
    console.log(e)
    // toast.update(toastId, {render: "An error occured.  Try checking your internet connection.", isLoading: false, autoClose: 3000, type: "error"});
    // toast.error("An error occured.  Try checking your internet connection.")
  }

}


export async function connectParties({tutor, student, subject, time, date, day}) {
  // const toastId = toast.loading("Requesting your item");
  try {
    const request = httpsCallable(functions, "connectParties");
    // const request = connectFunctionsEmulator(functions, "127.0.0.1", 5001);
    const { data:result } = await request({ tutor, student, subject, time, date, day });
    if (result && result.success == false) {
      // toast.update(toastId, {render: "Your cannot request more than three items at once.  Try requesting this item after you have picked up another item.  Thank you for your understanding.", type: "error", isLoading: false, autoClose: 6000});
      // return Promise.reject();
      return false;
    }
    // toast.update(toastId, {render: "Success!", type: "success", isLoading: false, autoClose: 2000});
    window.location.href = "http://www.trustyteens.com/success";
    return true;
  } catch (e) {
    // toast.update(toastId, {render: "Your cannot request more than three items at once.  Try requesting this item after you have picked up another item.  Thank you for your understanding.", type: "error", isLoading: false, autoClose: 6000});
    // return Promise.reject();
  }
}
